// import React, { useEffect, useState, useMemo } from "react";
// import { doc, getDoc } from "firebase/firestore";
// import { firestore } from "../../firebase";

// const db = firestore;

// // ─── helpers ─────────────────────────────────────────────────────────────────
// const fmt = (n) => (n == null ? "–" : Number(n).toLocaleString("nb-NO"));

// const PERIODS = [
//   {
//     id: "24h",
//     key: "last_24_hours",
//     totalKey: "last24Hours",
//     label: "Siste 24 timer",
//     short: "24 t",
//   },
//   {
//     id: "7d",
//     key: "last_7_days",
//     totalKey: "last7Days",
//     label: "Siste 7 dager",
//     short: "7 dager",
//   },
//   {
//     id: "30d",
//     key: "last_30_days",
//     totalKey: "last30Days",
//     label: "Siste 30 dager",
//     short: "30 dager",
//   },
//   {
//     id: "90d",
//     key: "last_90_days",
//     totalKey: "last90Days",
//     label: "Siste 90 dager",
//     short: "90 dager",
//   },
// ];

// const METRIC_LABEL = { visninger: "visninger", klikk: "klikk" };

// // ─── component ───────────────────────────────────────────────────────────────
// export default function StatsPage({ currentBusinessID }) {
//   const [locations, setLocations] = useState([]); // [{id, name}]
//   const [events, setEvents] = useState([]); // [{id, name}]
//   const [profilesData, setProfilesData] = useState([]);
//   const [totalViews, setTotalViews] = useState(null);
//   const [eventsData, setEventsData] = useState([]);
//   const [eventsTotalViews, setEventsTotalViews] = useState(null);
//   const [selectedId, setSelectedId] = useState("total");
//   const [scope, setScope] = useState("lokasjoner");
//   const [metric, setMetric] = useState("klikk"); // klikk is what we have today
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // ── load business + analytics (unchanged logic) ──────────────────────────
//   useEffect(() => {
//     if (!currentBusinessID) return;

//     const load = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         const bizSnap = await getDoc(doc(db, "businesses", currentBusinessID));
//         if (!bizSnap.exists()) throw new Error("Fant ikke bedriften.");

//         const menuIds = bizSnap.data().menus ?? [];
//         const eventIds = bizSnap.data().events ?? [];
//         if (menuIds.length === 0) {
//           setLoading(false);
//           return;
//         }

//         const locSnaps = await Promise.all(
//           menuIds.map((id) => getDoc(doc(db, "lokasjoner", id))),
//         );

//         const locs = locSnaps
//           .filter((s) => s.exists())
//           .map((s) => ({ id: s.id, name: s.data().locationName ?? s.id }));

//         setLocations(locs);

//                 const eventSnaps = await Promise.all(
//           eventIds.map((id) => getDoc(doc(db, "events", id))),
//         );

//         const events = eventSnaps
//           .filter((s) => s.exists())
//           .map((s) => ({ id: s.id, name: s.data().locationName ?? s.id }));

//         setEvents(events);

//         const ids = locs.map((l) => l.id).join(",");
//         const idsEvents = events.map((e) => e.id).join(",");
//         const res = await fetch(
//           `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/api/viewCounts/${ids}`,
//         );
//                 const eventRes = await fetch(
//           `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/api/viewCounts/${idsEvents}`,
//         );
//         if (!res.ok) throw new Error(`API-feil: ${res.status}`);
//         if (!eventRes.ok) throw new Error(`API-feil: ${eventRes.status}`);
//         const json = await res.json();
//         const jsonEvents = await eventRes.json();

//         setEventsData(jsonEvents.data ?? []);
//         setEventsTotalViews(jsonEvents.totalViews ?? null);
//         setProfilesData(json.data ?? []);
//         setTotalViews(json.totalViews ?? null);
//       } catch (err) {
//         console.error(err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     load();
//   }, [currentBusinessID]);

//   // ── derive totals for the currently selected metric ──────────────────────
//   // klikk → real API data, visninger → null placeholders (wire up later)
//   const totalsForMetric = (m) => (m === "klikk" ? totalViews : null);

//   const profileValueForMetric = (profile, periodKey, m) =>
//     m === "klikk" ? profile?.[periodKey] : null;

//   // ── value lookup for a given period + entity id ──────────────────────────
//   const valueFor = (entityId, period) => {
//     if (entityId === "total") {
//       return totalsForMetric(metric)?.[period.totalKey] ?? null;
//     }
//     const profile = profilesData.find((p) => p.location_id === entityId);
//     return profileValueForMetric(profile, period.key, metric);
//   };

//   // ── leaderboard (top entities by 7d) ─────────────────────────────────────
//   const leaderboard = useMemo(() => {
//     if (metric !== "klikk") return [];
//     return [...locations]
//       .map((loc) => {
//         const profile = profilesData.find((p) => p.location_id === loc.id);
//         return { ...loc, v: profile?.last_7_days ?? 0 };
//       })
//       .sort((a, b) => b.v - a.v);
//   }, [locations, profilesData, metric]);

//   const leaderMax = leaderboard[0]?.v || 1;

//   const scopeNoun = scope === "lokasjoner" ? "lokasjoner" : "arrangementer";
//   const entityHeader = scope === "lokasjoner" ? "Lokasjon" : "Arrangement";

//   // ── render ───────────────────────────────────────────────────────────────
//   return (
//     <>
//       <style>{CSS}</style>
//       <div className='sp-root'>
//         <header className='sp-header'>
//           <h1 className='sp-title'>
//             Statistikk<span className='sp-title-accent'>.</span>
//           </h1>
//           <p className='sp-sub'>
//             Hvor mange ganger{" "}
//             <b>
//               {scopeNoun === "lokasjoner"
//                 ? "lokasjonene dine"
//                 : "arrangementene dine"}
//             </b>{" "}
//             har blitt {metric === "klikk" ? "klikket på" : "vist"} på Mapli,
//             fordelt på tidsperiode og{" "}
//             {scope === "lokasjoner" ? "lokasjon" : "arrangement"}.
//           </p>
//         </header>

//         {/* scope tabs */}
//         <div className='sp-scope' role='tablist' aria-label='Type'>
//           <button
//             type='button'
//             className={`sp-scope-tab ${scope === "lokasjoner" ? "on" : ""}`}
//             onClick={() => setScope("lokasjoner")}
//             role='tab'
//             aria-selected={scope === "lokasjoner"}>
//             <span className='sp-scope-label'>
//               <svg
//                 width='18'
//                 height='18'
//                 viewBox='0 0 24 24'
//                 fill='none'
//                 stroke='currentColor'
//                 strokeWidth='1.8'
//                 strokeLinecap='round'
//                 strokeLinejoin='round'>
//                 <path d='M12 22s7-7.58 7-13a7 7 0 10-14 0c0 5.42 7 13 7 13z' />
//                 <circle cx='12' cy='9' r='2.5' />
//               </svg>
//               Lokasjoner
//             </span>
//             <span className='sp-scope-meta'>
//               {locations.length} {locations.length === 1 ? "aktiv" : "aktive"}
//             </span>
//           </button>
//           <button
//             type='button'
//             className={`sp-scope-tab ${scope === "arrangementer" ? "on" : ""}`}
//             onClick={() => setScope("arrangementer")}
//             role='tab'
//             aria-selected={scope === "arrangementer"}>
//             <span className='sp-scope-label'>
//               <svg
//                 width='18'
//                 height='18'
//                 viewBox='0 0 24 24'
//                 fill='none'
//                 stroke='currentColor'
//                 strokeWidth='1.8'
//                 strokeLinecap='round'
//                 strokeLinejoin='round'>
//                 <rect x='3' y='5' width='18' height='16' rx='2' />
//                 <path d='M3 9h18M8 3v4M16 3v4' />
//               </svg>
//               Arrangementer
//             </span>
//             <span className='sp-scope-meta'>Kommer snart</span>
//           </button>
//         </div>

//         {/* states */}
//         {loading && (
//           <div className='sp-state'>
//             <div className='sp-spinner' />
//             <span>Henter data…</span>
//           </div>
//         )}

//         {!loading && error && (
//           <div className='sp-state sp-state--error'>
//             <svg
//               viewBox='0 0 24 24'
//               fill='none'
//               stroke='currentColor'
//               strokeWidth='2'>
//               <circle cx='12' cy='12' r='10' />
//               <line x1='12' y1='8' x2='12' y2='12' />
//               <line x1='12' y1='16' x2='12.01' y2='16' />
//             </svg>
//             {error}
//           </div>
//         )}

//         {!loading && !error && locations.length === 0 && (
//           <div className='sp-state'>Ingen lokasjoner funnet.</div>
//         )}

//         {!loading && !error && locations.length > 0 && (
//           <>
//             {/* controls */}
//             <div className='sp-controls'>
//               <span className='sp-control-label'>{entityHeader}</span>
//               <div className='sp-select-wrap'>
//                 <select
//                   className='sp-select'
//                   value={selectedId}
//                   onChange={(e) => setSelectedId(e.target.value)}>
//                   <option value='total'>
//                     Alle {scopeNoun} · {locations.length}
//                   </option>
//                   {locations.map((loc) => (
//                     <option key={loc.id} value={loc.id}>
//                       {loc.name}
//                     </option>
//                   ))}
//                 </select>
//                 <svg
//                   className='sp-select-arrow'
//                   viewBox='0 0 10 6'
//                   fill='none'
//                   width='10'
//                   height='6'>
//                   <path
//                     d='M1 1l4 4 4-4'
//                     stroke='currentColor'
//                     strokeWidth='1.5'
//                     strokeLinecap='round'
//                     strokeLinejoin='round'
//                   />
//                 </svg>
//               </div>

//               <div className='sp-seg' role='tablist' aria-label='Metrikk'>
//                 <button
//                   type='button'
//                   className={metric === "visninger" ? "on" : ""}
//                   onClick={() => setMetric("visninger")}>
//                   Visninger
//                 </button>
//                 <button
//                   type='button'
//                   className={metric === "klikk" ? "on" : ""}
//                   onClick={() => setMetric("klikk")}>
//                   Klikk
//                 </button>
//               </div>

//               <span className='sp-spacer' />
//               <span className='sp-updated'>
//                 <span className='sp-dot' />
//                 {metric === "visninger" ? "Ikke aktivert ennå" : "Oppdatert nå"}
//               </span>
//             </div>

//             {/* stat cards */}
//             <section className='sp-cards'>
//               {PERIODS.map((p) => {
//                 const isFeature = p.id === "7d";
//                 return (
//                   <article
//                     key={p.id}
//                     className={`sp-card ${isFeature ? "sp-card-feature" : ""}`}>
//                     <div className='sp-card-label'>
//                       {p.label}
//                       {isFeature && (
//                         <span className='sp-card-pill'>UTVALGT</span>
//                       )}
//                     </div>
//                     <div className='sp-card-value'>
//                       {fmt(valueFor(selectedId, p))}
//                     </div>
//                     <div className='sp-card-unit'>{METRIC_LABEL[metric]}</div>
//                   </article>
//                 );
//               })}
//             </section>

//             {/* leaderboard — only show when we have klikk data and >1 location */}
//             {metric === "klikk" && locations.length > 1 && (
//               <section className='sp-panel'>
//                 <div className='sp-panel-head'>
//                   <h2>Topp {scopeNoun}</h2>
//                   <div className='sp-panel-meta'>
//                     Siste 7 dager · etter {METRIC_LABEL[metric]}
//                   </div>
//                 </div>
//                 <div className='sp-leader'>
//                   {leaderboard.map((it, i) => (
//                     <div
//                       key={it.id}
//                       className={`sp-leader-row ${i === 0 ? "top" : ""}`}>
//                       <div className='sp-leader-name'>
//                         <div className='sp-leader-rank'>{i + 1}</div>
//                         <div className='sp-leader-place'>{it.name}</div>
//                       </div>
//                       <div className='sp-leader-val'>{fmt(it.v)}</div>
//                       <div className='sp-leader-bar'>
//                         <span
//                           style={{ width: `${(it.v / leaderMax) * 100}%` }}
//                         />
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </section>
//             )}

//             {/* detailed table */}
//             <section className='sp-panel'>
//               <div className='sp-panel-head'>
//                 <h2>Detaljert oversikt</h2>
//                 <div className='sp-panel-meta'>
//                   Sammenligning på tvers av {scopeNoun}
//                 </div>
//               </div>
//               <table className='sp-table'>
//                 <thead>
//                   <tr>
//                     <th>{entityHeader}</th>
//                     {PERIODS.map((p) => (
//                       <th key={p.id} className='num'>
//                         {p.short}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td className='place'>
//                       <strong>Alle {scopeNoun}</strong>
//                       <span className='sub'>Totalt</span>
//                     </td>
//                     {PERIODS.map((p) => (
//                       <td key={p.id} className='num'>
//                         {fmt(totalsForMetric(metric)?.[p.totalKey])}
//                       </td>
//                     ))}
//                   </tr>
//                   {locations.map((loc) => {
//                     const profile = profilesData.find(
//                       (p) => p.location_id === loc.id,
//                     );
//                     return (
//                       <tr key={loc.id}>
//                         <td className='place'>
//                           <strong>{loc.name}</strong>
//                         </td>
//                         {PERIODS.map((p) => (
//                           <td key={p.id} className='num'>
//                             {fmt(profileValueForMetric(profile, p.key, metric))}
//                           </td>
//                         ))}
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </section>
//           </>
//         )}
//       </div>
//     </>
//   );
// }

// // ─── styles (scoped via .sp- prefix) ─────────────────────────────────────────
// const CSS = `
//   @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Geist:wght@400;500;600;700&display=swap');

//   .sp-root {
//     --sp-bg:        #f4ede1;
//     --sp-bg-tint:   #ede4d4;
//     --sp-paper:     #ffffff;
//     --sp-ink:       #15110d;
//     --sp-ink-soft:  #4a423a;
//     --sp-muted:     #8d8579;
//     --sp-coral:     #ef5a4d;
//     --sp-coral-soft:#fde3df;
//     --sp-coral-ink: #c14132;
//     --sp-line:      #e6dccc;
//     --sp-line-soft: #efe7d8;

//     font-family: 'Geist', system-ui, sans-serif;
//     color: var(--sp-ink);
//     font-size: 15px;
//     line-height: 1.45;
//     -webkit-font-smoothing: antialiased;
//     padding: 12px 4px 64px;
//     box-sizing: border-box;
//   }
//   .sp-root *, .sp-root *::before, .sp-root *::after { box-sizing: border-box; }

//   /* header */
//   .sp-header { margin-bottom: 28px; }
//   .sp-title {
//     font-family: 'Geist', sans-serif;
//     font-weight: 700;
//     font-size: clamp(32px, 4vw, 44px);
//     line-height: 1;
//     letter-spacing: -0.02em;
//     margin: 0 0 10px;
//     color: var(--sp-ink);
//   }
//   .sp-title-accent {
//     font-family: 'Instrument Serif', serif;
//     font-style: italic;
//     font-weight: 400;
//     color: var(--sp-coral);
//     letter-spacing: -0.01em;
//     margin-left: 2px;
//   }
//   .sp-sub {
//     color: var(--sp-ink-soft);
//     font-size: 14px;
//     margin: 0;
//     max-width: 560px;
//   }
//   .sp-sub b { color: var(--sp-ink); font-weight: 600; }

//   /* scope tabs */
//   .sp-scope {
//     display: grid;
//     grid-template-columns: 1fr 1fr;
//     gap: 14px;
//     margin-bottom: 24px;
//   }
//   .sp-scope-tab {
//     font: inherit;
//     text-align: left;
//     background: var(--sp-paper);
//     border: 1px solid var(--sp-line);
//     border-radius: 16px;
//     padding: 18px 22px;
//     cursor: pointer;
//     display: flex;
//     flex-direction: column;
//     gap: 4px;
//     position: relative;
//     transition: border-color .15s, color .15s;
//     color: var(--sp-ink-soft);
//   }
//   .sp-scope-tab:hover { border-color: #d8c9aa; }
//   .sp-scope-tab.on {
//     background: var(--sp-ink);
//     border-color: var(--sp-ink);
//     color: #fff;
//   }
//   .sp-scope-tab.on .sp-scope-meta { color: rgba(255,255,255,.65); }
//   .sp-scope-tab.on::after {
//     content: '';
//     position: absolute;
//     left: 22px; right: 22px; bottom: 10px;
//     height: 2px;
//     background: var(--sp-coral);
//     border-radius: 2px;
//   }
//   .sp-scope-label {
//     font-family: 'Geist', sans-serif;
//     font-size: 18px;
//     font-weight: 600;
//     letter-spacing: -0.01em;
//     color: var(--sp-ink);
//     display: flex; align-items: center; gap: 10px;
//   }
//   .sp-scope-tab.on .sp-scope-label { color: #fff; }
//   .sp-scope-meta {
//     font-size: 12px;
//     color: var(--sp-muted);
//     letter-spacing: .02em;
//     font-variant-numeric: tabular-nums;
//   }

//   /* states */
//   .sp-state {
//     display: flex;
//     align-items: center;
//     gap: 12px;
//     color: var(--sp-muted);
//     font-size: 14px;
//     padding: 24px 0;
//   }
//   .sp-state--error { color: var(--sp-coral-ink); }
//   .sp-state--error svg { width: 18px; height: 18px; flex-shrink: 0; }
//   .sp-spinner {
//     width: 16px; height: 16px;
//     border: 2px solid var(--sp-line);
//     border-top-color: var(--sp-coral);
//     border-radius: 50%;
//     animation: sp-spin 0.7s linear infinite;
//   }
//   @keyframes sp-spin { to { transform: rotate(360deg); } }

//   /* controls */
//   .sp-controls {
//     display: flex;
//     align-items: center;
//     gap: 14px;
//     flex-wrap: wrap;
//     margin-bottom: 22px;
//   }
//   .sp-control-label {
//     font-size: 12px;
//     text-transform: uppercase;
//     letter-spacing: 0.12em;
//     color: var(--sp-muted);
//     font-weight: 500;
//   }
//   .sp-select {
//   /* ... existing styles ... */
//   border: 1px solid var(--sp-line); /* ← default: neutral */
//   outline: none;
// }
// .sp-select:hover,
// .sp-select:focus,
// .sp-select:focus-visible {
//   border-color: var(--sp-coral); /* ← only on interaction */
//   outline: none; /* ← suppress browser default focus ring */
// }
//   .sp-select-arrow {
//   position: absolute;
//   right: 18px;
//   top: 50%;
//   transform: translateY(-50%);
//   width: 10px !important;
//   height: 6px !important;
//   color: var(--sp-ink);
//   pointer-events: none;
//   display: block;  /* ← add this */
//   flex-shrink: 0;  /* ← add this */
// }
//   .sp-seg {
//     display: inline-flex;
//     background: var(--sp-paper);
//     border: 1px solid var(--sp-line);
//     border-radius: 999px;
//     padding: 4px;
//     gap: 2px;
//   }
//   .sp-seg button {
//     font: inherit;
//     font-size: 13px;
//     font-weight: 500;
//     padding: 6px 16px;
//     border: 0;
//     background: transparent;
//     border-radius: 999px;
//     color: var(--sp-ink-soft);
//     cursor: pointer;
//   }
//   .sp-seg button.on {
//     background: var(--sp-ink);
//     color: #fff;
//   }
//   .sp-spacer { flex: 1; }
//   .sp-updated {
//     font-size: 12px;
//     color: var(--sp-muted);
//     display: inline-flex;
//     align-items: center;
//     gap: 8px;
//   }
//   .sp-dot {
//     width: 7px; height: 7px;
//     border-radius: 50%;
//     background: #41b06e;
//     box-shadow: 0 0 0 3px rgba(65,176,110,.18);
//   }

//   /* stat cards */
//   .sp-cards {
//     display: grid;
//     grid-template-columns: repeat(4, 1fr);
//     gap: 14px;
//     margin-bottom: 14px;
//   }
//   .sp-card {
//     background: var(--sp-paper);
//     border: 1px solid var(--sp-line);
//     border-radius: 18px;
//     padding: 22px;
//     transition: transform .18s ease, border-color .18s;
//   }
//   .sp-card:hover { transform: translateY(-2px); border-color: #d8c9aa; }
//   .sp-card-feature {
//     background: var(--sp-ink);
//     border-color: var(--sp-ink);
//     color: #fff;
//   }
//   .sp-card-feature .sp-card-label { color: rgba(255,255,255,.65); }
//   .sp-card-feature .sp-card-value { color: #fff; }
//   .sp-card-feature .sp-card-unit  { color: rgba(255,255,255,.6); }

//   .sp-card-label {
//     font-size: 11.5px;
//     font-weight: 500;
//     text-transform: uppercase;
//     letter-spacing: 0.14em;
//     color: var(--sp-muted);
//     display: flex;
//     align-items: center;
//     gap: 8px;
//   }
//   .sp-card-pill {
//     background: var(--sp-coral-soft);
//     color: var(--sp-coral-ink);
//     border-radius: 4px;
//     padding: 1px 6px;
//     font-size: 10px;
//     letter-spacing: .06em;
//   }
//   .sp-card-value {
//     font-family: 'Geist', sans-serif;
//     font-weight: 600;
//     font-size: 44px;
//     line-height: 1;
//     letter-spacing: -0.025em;
//     margin: 18px 0 4px;
//     font-variant-numeric: tabular-nums;
//     color: var(--sp-ink);
//   }
//   .sp-card-unit {
//     font-size: 13px;
//     color: var(--sp-muted);
//   }

//   /* panels */
//   .sp-panel {
//     background: var(--sp-paper);
//     border: 1px solid var(--sp-line);
//     border-radius: 18px;
//     padding: 26px 28px;
//     margin-top: 14px;
//   }
//   .sp-panel-head {
//     display: flex;
//     align-items: baseline;
//     justify-content: space-between;
//     gap: 18px;
//     margin-bottom: 6px;
//   }
//   .sp-panel-head h2 {
//     margin: 0;
//     font-family: 'Geist', sans-serif;
//     font-size: 18px;
//     font-weight: 600;
//     letter-spacing: -0.01em;
//     color: var(--sp-ink);
//   }
//   .sp-panel-meta { color: var(--sp-muted); font-size: 13px; }

//   /* leaderboard */
//   .sp-leader { margin-top: 8px; }
//   .sp-leader-row {
//     display: grid;
//     grid-template-columns: 1fr auto;
//     gap: 12px;
//     align-items: center;
//     padding: 14px 0;
//     border-bottom: 1px solid var(--sp-line-soft);
//   }
//   .sp-leader-row:last-child { border-bottom: 0; }
//   .sp-leader-name {
//     display: flex; align-items: center; gap: 12px;
//     min-width: 0;
//   }
//   .sp-leader-rank {
//     width: 22px; height: 22px;
//     border-radius: 50%;
//     background: var(--sp-bg);
//     color: var(--sp-ink-soft);
//     display: grid; place-items: center;
//     font-size: 11px;
//     font-weight: 600;
//     flex-shrink: 0;
//   }
//   .sp-leader-row.top .sp-leader-rank {
//     background: var(--sp-coral);
//     color: #fff;
//   }
//   .sp-leader-place {
//     font-weight: 500;
//     font-size: 14.5px;
//     color: var(--sp-ink);
//     white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
//   }
//   .sp-leader-val {
//     font-variant-numeric: tabular-nums;
//     font-weight: 600;
//     font-size: 15px;
//     text-align: right;
//   }
//   .sp-leader-bar {
//     grid-column: 1 / -1;
//     height: 4px;
//     background: var(--sp-bg);
//     border-radius: 999px;
//     overflow: hidden;
//   }
//   .sp-leader-bar > span {
//     display: block;
//     height: 100%;
//     background: var(--sp-coral);
//     border-radius: 999px;
//   }

//   /* table */
//   .sp-table {
//     width: 100%;
//     border-collapse: collapse;
//     margin-top: 14px;
//     font-variant-numeric: tabular-nums;
//   }
//   .sp-table th {
//     text-align: left;
//     font-size: 11px;
//     text-transform: uppercase;
//     letter-spacing: 0.12em;
//     color: var(--sp-muted);
//     font-weight: 500;
//     padding: 12px 16px;
//     border-bottom: 1px solid var(--sp-line);
//   }
//   .sp-table th.num { text-align: right; }
//   .sp-table td {
//     padding: 16px;
//     border-bottom: 1px solid var(--sp-line-soft);
//     font-size: 14px;
//     color: var(--sp-ink);
//   }
//   .sp-table td.num { text-align: right; font-weight: 500; }
//   .sp-table tbody tr:last-child td { border-bottom: 0; }
//   .sp-table tbody tr:hover { background: var(--sp-bg-tint); }
//   .sp-table td.place strong { font-weight: 600; }
//   .sp-table td.place .sub {
//     color: var(--sp-muted);
//     font-weight: 400;
//     font-size: 12.5px;
//     margin-left: 8px;
//   }

//   /* responsive */
//   @media (max-width: 900px) {
//     .sp-cards { grid-template-columns: repeat(2, 1fr); }
//     .sp-scope { grid-template-columns: 1fr; }
//   }
//   @media (max-width: 540px) {
//     .sp-cards { grid-template-columns: 1fr; }
//     .sp-controls { gap: 10px; }
//     .sp-select { min-width: 0; flex: 1; }
//   }
// `;

import React, { useEffect, useState, useMemo } from "react";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../firebase";

const db = firestore;

// ─── helpers ─────────────────────────────────────────────────────────────────
const fmt = (n) => (n == null ? "–" : Number(n).toLocaleString("nb-NO"));

const PERIODS = [
  {
    id: "24h",
    key: "last_24_hours",
    totalKey: "last24Hours",
    label: "Siste 24 timer",
    short: "24 t",
  },
  {
    id: "7d",
    key: "last_7_days",
    totalKey: "last7Days",
    label: "Siste 7 dager",
    short: "7 dager",
  },
  {
    id: "30d",
    key: "last_30_days",
    totalKey: "last30Days",
    label: "Siste 30 dager",
    short: "30 dager",
  },
  {
    id: "90d",
    key: "last_90_days",
    totalKey: "last90Days",
    label: "Siste 90 dager",
    short: "90 dager",
  },
];

const METRIC_LABEL = { visninger: "visninger", klikk: "klikk" };

// ─── component ───────────────────────────────────────────────────────────────
export default function StatsPage({ currentBusinessID }) {
  const [locations, setLocations] = useState([]);
  const [events, setEvents] = useState([]);
  const [profilesData, setProfilesData] = useState([]);
  const [totalViews, setTotalViews] = useState(null);
  const [eventsData, setEventsData] = useState([]);
  const [eventsTotalViews, setEventsTotalViews] = useState(null);
  const [selectedId, setSelectedId] = useState("total");
  const [scope, setScope] = useState("lokasjoner");
  const [metric, setMetric] = useState("klikk");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ── load business + analytics ─────────────────────────────────────────────
  useEffect(() => {
    if (!currentBusinessID) return;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const bizSnap = await getDoc(doc(db, "businesses", currentBusinessID));
        if (!bizSnap.exists()) throw new Error("Fant ikke bedriften.");

        const menuIds = bizSnap.data().menus ?? [];
        const eventIds = bizSnap.data().events ?? [];
        if (menuIds.length === 0) {
          setLoading(false);
          return;
        }

        const locSnaps = await Promise.all(
          menuIds.map((id) => getDoc(doc(db, "lokasjoner", id))),
        );
        const locs = locSnaps
          .filter((s) => s.exists())
          .map((s) => ({ id: s.id, name: s.data().locationName ?? s.id }));
        setLocations(locs);

        const eventSnaps = await Promise.all(
          eventIds.map((id) => getDoc(doc(db, "events", id))),
        );
        const evts = eventSnaps
          .filter((s) => s.exists())
          .map((s) => ({ id: s.id, name: s.data().locationName ?? s.id }));
        setEvents(evts);

        const ids = locs.map((l) => l.id).join(",");
        const idsEvents = evts.map((e) => e.id).join(",");

        const res = await fetch(
          `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/api/viewCounts/${ids}`,
        );
        if (!res.ok) throw new Error(`API-feil: ${res.status}`);
        const json = await res.json();
        setProfilesData(json.data ?? []);
        setTotalViews(json.totalViews ?? null);

        // Only fetch events analytics if there are events
        if (idsEvents) {
          const eventRes = await fetch(
            `https://us-central1-menuapp-4c413.cloudfunctions.net/tripadvisor/api/viewCounts/${idsEvents}`,
          );
          if (!eventRes.ok) throw new Error(`API-feil: ${eventRes.status}`);
          const jsonEvents = await eventRes.json();
          setEventsData(jsonEvents.data ?? []);
          setEventsTotalViews(jsonEvents.totalViews ?? null);
        }
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [currentBusinessID]);

  // ── reset selectedId when switching scope ─────────────────────────────────
  const handleScopeChange = (newScope) => {
    setScope(newScope);
    setSelectedId("total");
  };

  // ── scope-aware data accessors ────────────────────────────────────────────
  const isEvents = scope === "arrangementer";

  const activeEntities = isEvents ? events : locations;
  const activeData = isEvents ? eventsData : profilesData;
  const activeTotals = isEvents ? eventsTotalViews : totalViews;

  const totalsForMetric = (m) => (m === "klikk" ? activeTotals : null);

  const profileValueForMetric = (profile, periodKey, m) =>
    m === "klikk" ? profile?.[periodKey] : null;

  const valueFor = (entityId, period) => {
    if (entityId === "total") {
      return totalsForMetric(metric)?.[period.totalKey] ?? null;
    }
    const idField = isEvents ? "location_id" : "location_id"; // same field name from API
    const profile = activeData.find((p) => p[idField] === entityId);
    return profileValueForMetric(profile, period.key, metric);
  };

  // ── leaderboard (top entities by 7d) ─────────────────────────────────────
  const leaderboard = useMemo(() => {
    if (metric !== "klikk") return [];
    return [...activeEntities]
      .map((entity) => {
        const profile = activeData.find((p) => p.location_id === entity.id);
        return { ...entity, v: profile?.last_7_days ?? 0 };
      })
      .sort((a, b) => b.v - a.v);
  }, [activeEntities, activeData, metric]);

  const leaderMax = leaderboard[0]?.v || 1;

  const scopeNoun = isEvents ? "arrangementer" : "lokasjoner";
  const entityHeader = isEvents ? "Arrangement" : "Lokasjon";
  const hasData = activeEntities.length > 0;

  // ── render ───────────────────────────────────────────────────────────────
  return (
    <>
      <style>{CSS}</style>
      <div className='sp-root'>
        <header className='sp-header'>
          <h1 className='sp-title'>
            Statistikk<span className='sp-title-accent'>.</span>
          </h1>
          <p className='sp-sub'>
            Hvor mange ganger{" "}
            <b>{isEvents ? "arrangementene dine" : "lokasjonene dine"}</b> har
            blitt {metric === "klikk" ? "klikket på" : "vist"} i Mapli, fordelt
            på tidsperiode og {isEvents ? "arrangement" : "lokasjon"}.
          </p>
        </header>

        {/* scope tabs */}
        <div className='sp-scope' role='tablist' aria-label='Type'>
          <button
            type='button'
            className={`sp-scope-tab ${scope === "lokasjoner" ? "on" : ""}`}
            onClick={() => handleScopeChange("lokasjoner")}
            role='tab'
            aria-selected={scope === "lokasjoner"}>
            <span className='sp-scope-label'>
              <svg
                width='18'
                height='18'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='1.8'
                strokeLinecap='round'
                strokeLinejoin='round'>
                <path d='M12 22s7-7.58 7-13a7 7 0 10-14 0c0 5.42 7 13 7 13z' />
                <circle cx='12' cy='9' r='2.5' />
              </svg>
              Lokasjoner
            </span>
            <span className='sp-scope-meta'>
              {locations.length} {locations.length === 1 ? "aktiv" : "aktive"}
            </span>
          </button>

          <button
            type='button'
            className={`sp-scope-tab ${scope === "arrangementer" ? "on" : ""}`}
            onClick={() => handleScopeChange("arrangementer")}
            role='tab'
            aria-selected={scope === "arrangementer"}>
            <span className='sp-scope-label'>
              <svg
                width='18'
                height='18'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='1.8'
                strokeLinecap='round'
                strokeLinejoin='round'>
                <rect x='3' y='5' width='18' height='16' rx='2' />
                <path d='M3 9h18M8 3v4M16 3v4' />
              </svg>
              Arrangementer
            </span>
            <span className='sp-scope-meta'>
              {events.length} {events.length === 1 ? "aktiv" : "aktive"}
            </span>
          </button>
        </div>

        {/* states */}
        {loading && (
          <div className='sp-state'>
            <div className='sp-spinner' />
            <span>Henter data…</span>
          </div>
        )}

        {!loading && error && (
          <div className='sp-state sp-state--error'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'>
              <circle cx='12' cy='12' r='10' />
              <line x1='12' y1='8' x2='12' y2='12' />
              <line x1='12' y1='16' x2='12.01' y2='16' />
            </svg>
            {error}
          </div>
        )}

        {!loading && !error && !hasData && (
          <div className='sp-state'>Ingen {scopeNoun} funnet.</div>
        )}

        {!loading && !error && hasData && (
          <>
            {/* controls */}
            <div className='sp-controls'>
              <span className='sp-control-label'>{entityHeader}</span>
              <div className='sp-select-wrap'>
                <select
                  className='sp-select'
                  value={selectedId}
                  onChange={(e) => setSelectedId(e.target.value)}>
                  <option value='total'>
                    Alle {scopeNoun} · {activeEntities.length}
                  </option>
                  {activeEntities.map((entity) => (
                    <option key={entity.id} value={entity.id}>
                      {entity.name}
                    </option>
                  ))}
                </select>
                {/* <svg
                  className='sp-select-arrow'
                  viewBox='0 0 10 6'
                  fill='none'
                  width='10'
                  height='6'>
                  <path
                    d='M1 1l4 4 4-4'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg> */}
              </div>

              <div className='sp-seg' role='tablist' aria-label='Metrikk'>
                <button
                  type='button'
                  className={metric === "visninger" ? "on" : ""}
                  onClick={() => setMetric("visninger")}>
                  Visninger
                </button>
                <button
                  type='button'
                  className={metric === "klikk" ? "on" : ""}
                  onClick={() => setMetric("klikk")}>
                  Klikk
                </button>
              </div>

              <span className='sp-spacer' />
              <span className='sp-updated'>
                <span className='sp-dot' />
                {metric === "visninger" ? "Ikke aktivert ennå" : "Oppdatert nå"}
              </span>
            </div>

            {/* stat cards */}
            <section className='sp-cards'>
              {PERIODS.map((p) => {
                const isFeature = p.id === "7d";
                return (
                  <article
                    key={p.id}
                    className={`sp-card ${isFeature ? "sp-card-feature" : ""}`}>
                    <div className='sp-card-label'>
                      {p.label}
                      {isFeature && (
                        <span className='sp-card-pill'>UTVALGT</span>
                      )}
                    </div>
                    <div className='sp-card-value'>
                      {fmt(valueFor(selectedId, p))}
                    </div>
                    <div className='sp-card-unit'>{METRIC_LABEL[metric]}</div>
                  </article>
                );
              })}
            </section>

            {/* leaderboard — only when klikk data and >1 entity */}
            {metric === "klikk" && activeEntities.length > 1 && (
              <section className='sp-panel'>
                <div className='sp-panel-head'>
                  <h2>Topp {scopeNoun}</h2>
                  <div className='sp-panel-meta'>
                    Siste 7 dager · etter {METRIC_LABEL[metric]}
                  </div>
                </div>
                <div className='sp-leader'>
                  {leaderboard.map((it, i) => (
                    <div
                      key={it.id}
                      className={`sp-leader-row ${i === 0 ? "top" : ""}`}>
                      <div className='sp-leader-name'>
                        <div className='sp-leader-rank'>{i + 1}</div>
                        <div className='sp-leader-place'>{it.name}</div>
                      </div>
                      <div className='sp-leader-val'>{fmt(it.v)}</div>
                      <div className='sp-leader-bar'>
                        <span
                          style={{ width: `${(it.v / leaderMax) * 100}%` }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* detailed table */}
            <section className='sp-panel'>
              <div className='sp-panel-head'>
                <h2>Detaljert oversikt</h2>
                <div className='sp-panel-meta'>
                  Sammenligning på tvers av {scopeNoun}
                </div>
              </div>
              <table className='sp-table'>
                <thead>
                  <tr>
                    <th>{entityHeader}</th>
                    {PERIODS.map((p) => (
                      <th key={p.id} className='num'>
                        {p.short}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='place'>
                      <strong>Alle {scopeNoun}</strong>
                      <span className='sub'>Totalt</span>
                    </td>
                    {PERIODS.map((p) => (
                      <td key={p.id} className='num'>
                        {fmt(totalsForMetric(metric)?.[p.totalKey])}
                      </td>
                    ))}
                  </tr>
                  {activeEntities.map((entity) => {
                    const profile = activeData.find(
                      (p) => p.location_id === entity.id,
                    );
                    return (
                      <tr key={entity.id}>
                        <td className='place'>
                          <strong>{entity.name}</strong>
                        </td>
                        {PERIODS.map((p) => (
                          <td key={p.id} className='num'>
                            {fmt(profileValueForMetric(profile, p.key, metric))}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </section>
          </>
        )}
      </div>
    </>
  );
}

// ─── styles (scoped via .sp- prefix) ─────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Geist:wght@400;500;600;700&display=swap');

  .sp-root {
    --sp-bg:        #f4ede1;
    --sp-bg-tint:   #ede4d4;
    --sp-paper:     #ffffff;
    --sp-ink:       #15110d;
    --sp-ink-soft:  #4a423a;
    --sp-muted:     #8d8579;
    --sp-coral:     #ef5a4d;
    --sp-coral-soft:#fde3df;
    --sp-coral-ink: #c14132;
    --sp-line:      #e6dccc;
    --sp-line-soft: #efe7d8;

    font-family: 'Geist', system-ui, sans-serif;
    color: var(--sp-ink);
    font-size: 15px;
    line-height: 1.45;
    -webkit-font-smoothing: antialiased;
    padding: 12px 4px 64px;
    box-sizing: border-box;
  }
  .sp-root *, .sp-root *::before, .sp-root *::after { box-sizing: border-box; }

  /* header */
  .sp-header { margin-bottom: 28px; }
  .sp-title {
    font-family: 'Geist', sans-serif;
    font-weight: 700;
    font-size: clamp(32px, 4vw, 44px);
    line-height: 1;
    letter-spacing: -0.02em;
    margin: 0 0 10px;
    color: var(--sp-ink);
  }
  .sp-title-accent {
    font-family: 'Instrument Serif', serif;
    font-style: italic;
    font-weight: 400;
    color: var(--sp-coral);
    letter-spacing: -0.01em;
    margin-left: 2px;
  }
  .sp-sub {
    color: var(--sp-ink-soft);
    font-size: 14px;
    margin: 0;
    max-width: 560px;
  }
  .sp-sub b { color: var(--sp-ink); font-weight: 600; }

  /* scope tabs */
  .sp-scope {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;
    margin-bottom: 24px;
  }
  .sp-scope-tab {
    font: inherit;
    text-align: left;
    background: var(--sp-paper);
    border: 1px solid var(--sp-line);
    border-radius: 16px;
    padding: 18px 22px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 4px;
    position: relative;
    transition: border-color .15s, color .15s;
    color: var(--sp-ink-soft);
  }
  .sp-scope-tab:hover { border-color: #d8c9aa; }
  .sp-scope-tab.on {
    background: var(--sp-ink);
    border-color: var(--sp-ink);
    color: #fff;
  }
  .sp-scope-tab.on .sp-scope-meta { color: rgba(255,255,255,.65); }
  .sp-scope-tab.on::after {
    content: '';
    position: absolute;
    left: 22px; right: 22px; bottom: 10px;
    height: 2px;
    background: var(--sp-coral);
    border-radius: 2px;
  }
  .sp-scope-label {
    font-family: 'Geist', sans-serif;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.01em;
    color: var(--sp-ink);
    display: flex; align-items: center; gap: 10px;
  }
  .sp-scope-tab.on .sp-scope-label { color: #fff; }
  .sp-scope-meta {
    font-size: 12px;
    color: var(--sp-muted);
    letter-spacing: .02em;
    font-variant-numeric: tabular-nums;
  }

  /* states */
  .sp-state {
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--sp-muted);
    font-size: 14px;
    padding: 24px 0;
  }
  .sp-state--error { color: var(--sp-coral-ink); }
  .sp-state--error svg { width: 18px; height: 18px; flex-shrink: 0; }
  .sp-spinner {
    width: 16px; height: 16px;
    border: 2px solid var(--sp-line);
    border-top-color: var(--sp-coral);
    border-radius: 50%;
    animation: sp-spin 0.7s linear infinite;
  }
  @keyframes sp-spin { to { transform: rotate(360deg); } }

  /* controls */
  .sp-controls {
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
    margin-bottom: 22px;
  }
  .sp-control-label {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: var(--sp-muted);
    font-weight: 500;
  }
  .sp-select-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
  // .sp-select {
  //   font: inherit;
  //   font-size: 14px;
  //   font-weight: 500;
  //   color: var(--sp-ink);
  //   background: var(--sp-paper);
  //   border: 1px solid var(--sp-line);
  //   border-radius: 999px;
  //   padding: 8px 40px 8px 18px;
  //   appearance: none;
  //   cursor: pointer;
  //   outline: none;
  //   min-width: 200px;
  // }
  // .sp-select:hover,
  // .sp-select:focus,
  // .sp-select:focus-visible {
  //   border-color: var(--sp-coral);
  //   outline: none;
  // }
  // .sp-select-arrow {
  //   position: absolute;
  //   right: 18px;
  //   top: 50%;
  //   transform: translateY(-50%);
  //   width: 10px !important;
  //   height: 6px !important;
  //   color: var(--sp-ink);
  //   pointer-events: none;
  //   display: block;
  //   flex-shrink: 0;
  // }
  .sp-select:hover,
.sp-select:focus,
.sp-select:focus-visible {
  border-color: var(--sp-coral); /* ← only on interaction */
  outline: none; /* ← suppress browser default focus ring */
}
//   .sp-select-arrow {
//   position: absolute;
//   right: 18px;
//   top: 50%;
//   transform: translateY(-50%);
//   width: 10px !important;
//   height: 6px !important;
//   color: var(--sp-ink);
//   pointer-events: none;
//   display: block;  /* ← add this */
//   flex-shrink: 0;  /* ← add this */
// }
  .sp-seg {
    display: inline-flex;
    background: var(--sp-paper);
    border: 1px solid var(--sp-line);
    border-radius: 999px;
    padding: 4px;
    gap: 2px;
  }
  .sp-seg button {
    font: inherit;
    font-size: 13px;
    font-weight: 500;
    padding: 6px 16px;
    border: 0;
    background: transparent;
    border-radius: 999px;
    color: var(--sp-ink-soft);
    cursor: pointer;
  }
  .sp-seg button.on {
    background: var(--sp-ink);
    color: #fff;
  }
  .sp-spacer { flex: 1; }
  .sp-updated {
    font-size: 12px;
    color: var(--sp-muted);
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  .sp-dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #41b06e;
    box-shadow: 0 0 0 3px rgba(65,176,110,.18);
  }

  /* stat cards */
  .sp-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-bottom: 14px;
  }
  .sp-card {
    background: var(--sp-paper);
    border: 1px solid var(--sp-line);
    border-radius: 18px;
    padding: 22px;
    transition: transform .18s ease, border-color .18s;
  }
  .sp-card:hover { transform: translateY(-2px); border-color: #d8c9aa; }
  .sp-card-feature {
    background: var(--sp-ink);
    border-color: var(--sp-ink);
    color: #fff;
  }
  .sp-card-feature .sp-card-label { color: rgba(255,255,255,.65); }
  .sp-card-feature .sp-card-value { color: #fff; }
  .sp-card-feature .sp-card-unit  { color: rgba(255,255,255,.6); }

  .sp-card-label {
    font-size: 11.5px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: var(--sp-muted);
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .sp-card-pill {
    background: var(--sp-coral-soft);
    color: var(--sp-coral-ink);
    border-radius: 4px;
    padding: 1px 6px;
    font-size: 10px;
    letter-spacing: .06em;
  }
  .sp-card-value {
    font-family: 'Geist', sans-serif;
    font-weight: 600;
    font-size: 44px;
    line-height: 1;
    letter-spacing: -0.025em;
    margin: 18px 0 4px;
    font-variant-numeric: tabular-nums;
    color: var(--sp-ink);
  }
  .sp-card-unit {
    font-size: 13px;
    color: var(--sp-muted);
  }

  /* panels */
  .sp-panel {
    background: var(--sp-paper);
    border: 1px solid var(--sp-line);
    border-radius: 18px;
    padding: 26px 28px;
    margin-top: 14px;
  }
  .sp-panel-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 6px;
  }
  .sp-panel-head h2 {
    margin: 0;
    font-family: 'Geist', sans-serif;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.01em;
    color: var(--sp-ink);
  }
  .sp-panel-meta { color: var(--sp-muted); font-size: 13px; }

  /* leaderboard */
  .sp-leader { margin-top: 8px; }
  .sp-leader-row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: center;
    padding: 14px 0;
    border-bottom: 1px solid var(--sp-line-soft);
  }
  .sp-leader-row:last-child { border-bottom: 0; }
  .sp-leader-name {
    display: flex; align-items: center; gap: 12px;
    min-width: 0;
  }
  .sp-leader-rank {
    width: 22px; height: 22px;
    border-radius: 50%;
    background: var(--sp-bg);
    color: var(--sp-ink-soft);
    display: grid; place-items: center;
    font-size: 11px;
    font-weight: 600;
    flex-shrink: 0;
  }
  .sp-leader-row.top .sp-leader-rank {
    background: var(--sp-coral);
    color: #fff;
  }
  .sp-leader-place {
    font-weight: 500;
    font-size: 14.5px;
    color: var(--sp-ink);
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .sp-leader-val {
    font-variant-numeric: tabular-nums;
    font-weight: 600;
    font-size: 15px;
    text-align: right;
  }
  .sp-leader-bar {
    grid-column: 1 / -1;
    height: 4px;
    background: var(--sp-bg);
    border-radius: 999px;
    overflow: hidden;
  }
  .sp-leader-bar > span {
    display: block;
    height: 100%;
    background: var(--sp-coral);
    border-radius: 999px;
  }

  /* table */
  .sp-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 14px;
    font-variant-numeric: tabular-nums;
  }
  .sp-table th {
    text-align: left;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: var(--sp-muted);
    font-weight: 500;
    padding: 12px 16px;
    border-bottom: 1px solid var(--sp-line);
  }
  .sp-table th.num { text-align: right; }
  .sp-table td {
    padding: 16px;
    border-bottom: 1px solid var(--sp-line-soft);
    font-size: 14px;
    color: var(--sp-ink);
  }
  .sp-table td.num { text-align: right; font-weight: 500; }
  .sp-table tbody tr:last-child td { border-bottom: 0; }
  .sp-table tbody tr:hover { background: var(--sp-bg-tint); }
  .sp-table td.place strong { font-weight: 600; }
  .sp-table td.place .sub {
    color: var(--sp-muted);
    font-weight: 400;
    font-size: 12.5px;
    margin-left: 8px;
  }

  /* responsive */
  @media (max-width: 900px) {
    .sp-cards { grid-template-columns: repeat(2, 1fr); }
    .sp-scope { grid-template-columns: 1fr; }
  }
  @media (max-width: 540px) {
    .sp-cards { grid-template-columns: 1fr; }
    .sp-controls { gap: 10px; }
    .sp-select { min-width: 0; flex: 1; }
  }
`;
